export default "__VITE_ASSET__BoEI26UA__"